var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: {
      c_night: _vm.night
    }
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.article1.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.article1.author))]), _vm._v(" "), _c('div', {
    staticClass: "content_c",
    domProps: {
      "innerHTML": _vm._s(_vm.article1.content)
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('footer', [_vm._v("\n      全文完  共" + _vm._s(_vm.article1.wc) + "字\n    ")])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.4@vue-loader/lib/template-compiler?{"id":"data-v-84d8c60e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@13.0.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content.vue
// module id = Punr
// module chunks = 1